import { Component, OnDestroy, OnInit } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { NgbConfig, NgbAlertModule } from '@ng-bootstrap/ng-bootstrap';
import { HeaderComponent } from './header/header.component';
import { LoggerService } from './shared/logger.service';
import { SettingsService } from './settings/settings.service';

import { LoadingIndicatorComponent } from './shared/components/loading-indicator/loading-indicator.component';
import { AuthTokenService } from './auth/auth-token.service';
import { AppStateService } from './shared/app-state.service';
import { FooterComponent } from './footer/footer.component';
import { BehaviorSubject, Subscription } from 'rxjs';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, NgbAlertModule,
    RouterLink,
    RouterLinkActive,
    HeaderComponent,
    LoadingIndicatorComponent,
    FooterComponent
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'db-manager-app';

  private _isLoggedIn = new BehaviorSubject<boolean>(this.authTokenService.loggedIn);
  get isLoggedIn() {
    return this._isLoggedIn.getValue();
  }
  set isLoggedIn(val: boolean) {
    this._isLoggedIn.next(val);
  }
  private _subs: Subscription[] = [];

  constructor(
    ngbConfig: NgbConfig,
    private logger: LoggerService,
    private settingsService: SettingsService,
    private authTokenService: AuthTokenService,
    private appStateService: AppStateService
  ) {
    // ngbConfig.animation = false;
  }

  ngOnInit(): void {
    // this.logger.debug('app component: ngOnInit...');
    // console.log(`Wally Rules`);
    // this.trackerService
    // window.electronAPI.onSendDefaultSettings((event: any, defaults: IEnvVars) => {
    //   this.logger.log(`${event}: `, JSON.stringify(defaults));
    this.settingsService.initialize();
    this.appStateService.initialize();
    //   this.apiService.setApiUrl(this.settingsService.settings?.apiUrl)
    // });
    // window.electronAPI.onKillTheApp((event: any, args: any) => {
    //   this.logger.log(`kill-the-app`, args);
    //   this.authTokenService.removeToken();
    //   window.electronAPI.quitTheApp(`tokens removed...`);
    // });
    // this.logger.log(window.electronAPI.sendSettings(args))
    this._subs.push(this.authTokenService.isLoggedIn$.subscribe(status => {
      // this.logger.debug('status changed: **>> ', status);
      this.isLoggedIn = status;
    }));

  }

  ngOnDestroy(): void {
    // this.logger.debug('ngOnDestroy...');
    this._subs.forEach(s => s.unsubscribe());
  }

}
